import { Component, OnInit, OnDestroy } from '@angular/core';
import { TimeCardService } from "../services/timecard/timecard.service";
import { WeekService } from "../services/week/week.service";
import { Week } from "../models/week";
import { ReturnObject } from '../models/returnObject';
import { ApiTimecard } from '../models/apiTimecard';
import { InternalMsgService } from '../services/internal.msg.service';
import { AccountService } from '../services/account.service';
import { Subject, Subscription } from 'rxjs';
import { AccountItem } from '../models/accountitem';
import { StatusMessagesService } from '../services/statusmessage.service';

@Component({
    selector: 'recent-timecards-component',
    templateUrl: './recenttimecards.component.html'
})
export class RecentTimecardsComponent implements OnInit, OnDestroy {
    loggedAccount: AccountItem = new AccountItem();
    weeks: Array<Week> = [];
    selectedWeek: Week = new Week();
    msgSubscr: Subscription = new Subscription();
    spinnerMessage: string = 'Please wait, data is fetched';
    private thisWeek: Subject<Week> = new Subject<Week>();

    constructor(private weekService: WeekService,
                private timecardService: TimeCardService,
                private msgService: InternalMsgService,
                private accountService: AccountService,
                private statusMessagesService: StatusMessagesService) {
    }

    // ----------------------------------------------------------------------------------
    // -- Life cycle hooks
    // ----------------------------------------------------------------------------------
    ngOnInit(): void {
        this.msgService.onSelectedMenuSet( 2 );
        this.loggedAccount = this.accountService.getAccount();

        this.getWeeks();
        this.thisWeek
            .subscribe( week => {
            if ( week ) {
                this.getTimeCard(week)
            }
        }); 
    }

    ngOnDestroy(): void {
        this.thisWeek.unsubscribe();
    }

    // ----------------------------------------------------------------------------------
    // -- HTTP 
    // ----------------------------------------------------------------------------------
    getWeeks(): void {
        this.msgService.ontoggleSpinnerSet(true);

        this.weekService.getNonReportableWeeks(this.loggedAccount.email)
            .subscribe( { 
                next: (data: ReturnObject<Week[]>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }

                    this.weeks = Week.fromJSONArray(data.value);
                    this.sortWeeks();
                    this.setListWeekString();
                    this.selectedWeek = this.weeks[0];
                    this.thisWeek.next( this.selectedWeek );
                },
                error: (err) => {         
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {         
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }

    getTimeCard(week: Week): void {
        this.msgService.ontoggleSpinnerSet(true);
        this.selectedWeek = week;
        if (this.selectedWeek != null) {
            this.timecardService.retrieveTimeCard(this.loggedAccount.email, this.selectedWeek.timeCardId, this.selectedWeek.status.toLowerCase() == 'submitted')
            .subscribe( { 
                next: (timeCard: ReturnObject<ApiTimecard>) => {
                    if (timeCard.isFailure) {
                        this.statusMessagesService.showToasterError('Error', timeCard.failureMessage);
                        return;
                    }
                    if (timeCard.value != null) {
                        this.selectedWeek.timeCard = Week.fromApi(timeCard.value).timeCard;
                    }
                },
                error: (err) => {         
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {         
                    this.msgService.ontoggleSpinnerSet(false);
                }
            });
        }
    }

    unlockTimeCard(): void {
        this.msgService.ontoggleSpinnerSet(true);
        this.timecardService.unlockTimeCard(this.loggedAccount.email, this.selectedWeek.timeCardId)
            .subscribe( { 
                next: (data: ReturnObject<string>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    this.weeks = [];
                    this.selectedWeek = new Week();
                    
                    this.getWeeks();
                    this.statusMessagesService.showToasterSuccess('Unlocked succeded', data.value);
                },
                error: (err) => {         
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {         
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }


    // ----------------------------------------------------------------------------------
    // -- DATA MANIPULATION 
    // ----------------------------------------------------------------------------------
    setListWeekString(): void {
        this.weeks.forEach(item => {
            let first = item.firstDayOfWeek.split('T')[0];
            let last = item.lastDayOfWeek.split('T')[0];
            item.displayWeek = `Week: ${item.weekNo.slice(4, 6)}: ${first} to ${last}`;
        });
    }

    sortWeeks(): void {
        this.weeks = this.weeks.sort(function (a, b) {
            return a.weekNo == b.weekNo 
                ? 0 
                : +(a.weekNo <= b.weekNo) || -1;
        });
    }

    getDateFromWeekDay(weekDay: number): Date {
        if (!this.selectedWeek) {
            return new Date();
        }

        const date = new Date(this.selectedWeek.firstDayOfWeek);
        date.setDate(date.getDate() + weekDay);
        return date;
    }
}
